

































































import {
  defineComponent, computed, PropType,
} from '@vue/composition-api';
import type { RightSummaryType } from '@/api/rights/types';
import { GalileoExpStyleEnum } from '@/api/rights/types';
import {
  rightsBottomDescriptionEnum,
  rightsServiceMapping,
} from '../rightsServiceMapping';
import RightsCardContent from './RightsCardContent.vue';

interface Props {
  showSpeed: boolean;
  rightSummary: RightSummaryType | null;
  rightscheckTipsShow: boolean;
  isChecked: boolean;
  isRightDiscountUser?: boolean;
}

export default defineComponent({
  name: 'RightsTabContainer',
  components: {
    RightsCardContent,
  },
  props: {
    /** 是否显示极速通道 */
    showSpeed: {
      type: Boolean,
      required: true,
    },
    /** 权益摘要信息 */
    rightSummary: {
      type: Object as PropType<RightSummaryType>,
      default: null,
    },
    /** 是否显示勾选提示 */
    rightscheckTipsShow: {
      type: Boolean,
      default: false,
    },
    /** 是否已勾选 */
    isChecked: {
      type: Boolean,
      default: false,
    },
    /** 是否为折扣用户 */
    isRightDiscountUser: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['checkChange', 'openContract', 'cardTabChange', 'showRightsDetail'],
  setup(props: Props, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
    /** 获取当前权益服务文案 */
    const currentRightsServiceText = computed(
      () => rightsServiceMapping.getRightsServiceText(props.rightSummary || undefined),
    );

    /** 底部描述文案 */
    const rightsBottomDescription = computed(() => {
      if (currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.EQUITY_PROVIDER) {
        return '权益由臻有钱及权益方提供，与最终放款机构无关';
      }
      if (currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.CHANNEL_EQUITY) {
        return '权益服务由合作方提供，哈啰只负责展示';
      }
      return '';
    });

    /** 处理勾选状态变更 */
    const handleCheckChange = () => {
      emit('checkChange');
    };

    /** 处理打开合同 */
    const handleOpenContract = () => {
      emit('openContract');
    };

    /** 处理卡片内的 tab 切换 */
    const handleCardTabChange = () => {
      emit('cardTabChange');
    };

    /** 处理显示权益详情 */
    const handleShowRightsDetail = (rightSummary: RightSummaryType) => {
      emit('showRightsDetail', rightSummary);
    };

    const isStyleB = computed(
      () => props.rightSummary?.extraInfo?.style === GalileoExpStyleEnum.STYLE_B,
    );

    return {
      rightsBottomDescription,
      handleCheckChange,
      handleOpenContract,
      handleCardTabChange,
      handleShowRightsDetail,
      isStyleB,
    };
  },
});
